// auth.reducer
import { authConstants, userConstants } from "../actions/constants";

const emptySubscription = {
    type: "none",
    plan: "none",
    validUntil: null,
    autoRenew: false,
    status: "inactive",
    canceledAt: null,
    lastRenewalAt: null,
    nextBillingAt: null
};

const normalizeUser = (user = {}) => {
    return {
        ...user,
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        picture: user.picture || "",
        role: user.role || "user",
        trafficSavings: user.trafficSavings !== undefined ? user.trafficSavings : true,
        siteThemeType: user.siteThemeType === "black" ? "black" : "white",
        balance: Number(user.balance || 0),
        subscription: {
            ...emptySubscription,
            ...(user.subscription || {})
        }
    };
};

const initState = {
    token: null,
    searchShow: false,
    user: normalizeUser(),
    authenticate: false,
    authenticating: false,
    loading: false,
    error: null,
    showAlertAuth: false,
    variantAlertAuth: "",
    textAlertAuth: "",
    showAlert: false,
    variantAlert: "",
    message: "",
    visibleButtonBuy: false,
    showModalUser: false,
    modalMode: "login",
    modalRole: "user",
    showSettingModal: false,
    showPasswordResetModal: false,
    emailVerificationLoading: false,
    emailVerificationSent: false,
    emailVerificationMessage: "",
    emailVerificationError: null,
    passwordResetLoading: false,
    passwordResetMessage: "",
    passwordResetError: null
};

const getUserFromPayload = (payload) => {
    if (!payload) return null;
    if (payload.user) return payload.user;
    if (payload.data?.user) return payload.data.user;
    if (payload.data?._id) return payload.data;
    if (payload._id) return payload;

    return null;
};

const getTokenFromPayload = (payload, state) => {
    return payload?.token || payload?.data?.token || state.token || localStorage.getItem("token");
};

const saveUserToLocalStorage = (user) => {
    const nextUser = normalizeUser(user);
    localStorage.setItem("user", JSON.stringify(nextUser));

    return nextUser;
};

const mergeUserToLocalStorage = (currentUser, patch) => {
    const nextUser = normalizeUser({
        ...(currentUser || {}),
        ...(patch || {})
    });

    localStorage.setItem("user", JSON.stringify(nextUser));

    return nextUser;
};

export default (state = initState, action) => {
    switch (action.type) {
        case userConstants.USER_UPDATE_SITE_THEME_TYPE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case userConstants.USER_UPDATE_SITE_THEME_TYPE_SUCCESS: {
            const responseUser = action.payload?.user || {};
            const nextUser = mergeUserToLocalStorage(state.user, responseUser);

            return {
                ...state,
                user: nextUser,
                loading: false,
                message: action.payload?.message || "Тема обновлена",
                showAlert: true,
                variantAlert: "success",
            };
        }

        case userConstants.USER_UPDATE_SITE_THEME_TYPE_FAILURE:
            return {
                ...state,
                message: action.payload?.message || action.payload?.error || "Ошибка обновления темы",
                showAlert: true,
                variantAlert: "warning",
                loading: false,
            };

        case userConstants.USER_UPDATE_TRAFFIC_SAVING_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case userConstants.USER_UPDATE_TRAFFIC_SAVING_SUCCESS: {
            const responseUser = action.payload?.user || {};
            const nextUser = mergeUserToLocalStorage(state.user, responseUser);

            return {
                ...state,
                user: nextUser,
                loading: false,
                message: action.payload?.message || "Настройка качества фото обновлена",
                showAlert: true,
                variantAlert: "success",
            };
        }

        case userConstants.USER_UPDATE_TRAFFIC_SAVING_FAILURE:
            return {
                ...state,
                message: action.payload?.message || action.payload?.error || "Ошибка обновления качества фото",
                showAlert: true,
                variantAlert: "warning",
                loading: false,
            };

        case userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_SUCCESS: {
            const nextUser = saveUserToLocalStorage(action.payload.user);

            return {
                ...state,
                loading: false,
                message: action.payload.message,
                showAlert: true,
                variantAlert: "success",
                user: nextUser
            };
        }

        case userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE:
            return {
                ...state,
                message: action.payload?.message || action.payload?.error || "Ошибка подписки",
                showAlert: true,
                variantAlert: "warning",
                loading: false,
            };

        case userConstants.UPDATE_USER_REGION_REQUEST:
            return {
                ...state,
                loading: false,
            };

        case userConstants.UPDATE_USER_REGION_SUCCESS:
            return {
                ...state,
                message: action.payload.message,
                loading: false,
                showAlert: true,
                variantAlert: "success"
            };

        case userConstants.UPDATE_USER_REGION_FAILURE:
            return {
                ...state,
                message: action.payload.message,
                loading: false,
                showAlert: true,
                variantAlert: "warning"
            };

        case authConstants.SIGNUP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                emailVerificationSent: false,
                emailVerificationMessage: "",
                emailVerificationError: null
            };

        case authConstants.SIGNUP_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                emailVerificationSent: !!action.payload?.emailVerificationSent,
                emailVerificationMessage: action.payload?.message || ""
            };

        case authConstants.SIGNUP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.message || action.payload || null
            };

        case authConstants.LOGIN_REQUEST:
            return {
                ...state,
                authenticating: true,
                loading: true,
                error: null
            };

        case authConstants.LOGIN_SUCCESS: {
            const payloadUser = getUserFromPayload(action.payload);

            if (!payloadUser) {
                return {
                    ...state,
                    loading: false,
                    authenticating: false,
                    error: null
                };
            }

            const nextUser = saveUserToLocalStorage(payloadUser);
            const token = getTokenFromPayload(action.payload, state);
            const keepModalOpen = !!action.payload?.keepModalOpen;

            if (token) {
                localStorage.setItem("token", token);
            }

            return {
                ...state,
                user: nextUser,
                token,
                loading: false,
                authenticate: true,
                authenticating: false,
                showModalUser: keepModalOpen,
                modalMode: keepModalOpen ? (action.payload?.modalMode || "signup") : state.modalMode,
                modalRole: keepModalOpen ? (payloadUser.role || state.modalRole) : state.modalRole,
                error: null
            };
        }

        case authConstants.LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                authenticating: false,
                authenticate: false,
                error: action.payload?.error || action.payload || null
            };

        case authConstants.LOGOUT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case authConstants.LOGOUT_SUCCESS:
            return {
                ...initState,
                loading: false,
                showAlertAuth: true,
                variantAlertAuth: "success",
                textAlertAuth: action.payload.message
            };

        case authConstants.LOGOUT_BY_SESSION_EXPIRED:
            return {
                ...initState,
                loading: false,
                showModalUser: true,
                modalMode: "login",
                showAlertAuth: true,
                variantAlertAuth: "warning",
                textAlertAuth: "Сессия истекла. Войдите заново."
            };

        case authConstants.LOGOUT_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };

        case authConstants.EMAIL_VERIFICATION_SEND_REQUEST:
            return {
                ...state,
                emailVerificationLoading: true,
                emailVerificationError: null,
                emailVerificationMessage: ""
            };

        case authConstants.EMAIL_VERIFICATION_SEND_SUCCESS:
            return {
                ...state,
                emailVerificationLoading: false,
                emailVerificationSent: true,
                emailVerificationMessage: action.payload?.message || "Код подтверждения отправлен на email",
                emailVerificationError: null
            };

        case authConstants.EMAIL_VERIFICATION_SEND_FAILURE:
            return {
                ...state,
                emailVerificationLoading: false,
                emailVerificationError: action.payload?.message || "Ошибка отправки кода подтверждения",
                emailVerificationMessage: ""
            };

        case authConstants.EMAIL_VERIFICATION_CONFIRM_REQUEST:
            return {
                ...state,
                emailVerificationLoading: true,
                emailVerificationError: null
            };

        case authConstants.EMAIL_VERIFICATION_CONFIRM_SUCCESS: {
            const nextUser = mergeUserToLocalStorage(state.user, action.payload?.user || {});

            return {
                ...state,
                user: nextUser,
                token: action.payload?.token || state.token,
                showModalUser: false,
                emailVerificationLoading: false,
                emailVerificationSent: false,
                emailVerificationMessage: action.payload?.message || "Email успешно подтверждён",
                emailVerificationError: null
            };
        }

        case authConstants.EMAIL_VERIFICATION_CONFIRM_FAILURE:
            return {
                ...state,
                emailVerificationLoading: false,
                emailVerificationError: action.payload?.message || "Ошибка подтверждения email"
            };

        case authConstants.PASSWORD_RESET_REQUEST_REQUEST:
        case authConstants.PASSWORD_RESET_CONFIRM_REQUEST:
            return {
                ...state,
                passwordResetLoading: true,
                passwordResetError: null,
                passwordResetMessage: ""
            };

        case authConstants.PASSWORD_RESET_REQUEST_SUCCESS:
        case authConstants.PASSWORD_RESET_CONFIRM_SUCCESS:
            return {
                ...state,
                passwordResetLoading: false,
                passwordResetMessage: action.payload?.message || "",
                passwordResetError: null
            };

        case authConstants.PASSWORD_RESET_REQUEST_FAILURE:
        case authConstants.PASSWORD_RESET_CONFIRM_FAILURE:
            return {
                ...state,
                passwordResetLoading: false,
                passwordResetError: action.payload?.message || "Ошибка восстановления пароля",
                passwordResetMessage: ""
            };

        case authConstants.SHOW_MODAL_USER: {
            if (action.payload) {
                return {
                    ...state,
                    showModalUser: action.payload.forceShow !== undefined ? action.payload.forceShow : true,
                    modalMode: action.payload.mode || state.modalMode,
                    modalRole: action.payload.role || state.modalRole
                };
            }

            return {
                ...state,
                showModalUser: !state.showModalUser
            };
        }

        case authConstants.SHOW_PASSWORD_RESET_MODAL:
            return {
                ...state,
                showPasswordResetModal: action.payload !== undefined ? action.payload : !state.showPasswordResetModal
            };

        case authConstants.SHOW_SETTING_MODAL:
            return {
                ...state,
                showSettingModal: !state.showSettingModal
            };

        case authConstants.SET_CLOSE_ALERT:
            return {
                ...state,
                showAlertAuth: false,
                showAlert: false
            };

        case authConstants.SHOW_SEARCH_SHOW:
            return {
                ...state,
                searchShow: action.payload,
            };

        case authConstants.UPDATE_USER_BALANCE: {
            const nextBalance = Number(action.payload || 0);
            const nextUser = mergeUserToLocalStorage(state.user, {
                balance: nextBalance
            });

            return {
                ...state,
                user: nextUser
            };
        }

        case authConstants.UPDATE_USER_SUBSCRIPTION: {
            const nextUser = mergeUserToLocalStorage(state.user, {
                subscription: {
                    ...emptySubscription,
                    ...(action.payload || {})
                }
            });

            return {
                ...state,
                user: nextUser
            };
        }

        default:
            return state;
    }
};

export const setCloseAlertAuth = (payload) => ({
    type: authConstants.SET_CLOSE_ALERT,
    payload
});

export const setSearchShow = (payload) => ({
    type: authConstants.SHOW_SEARCH_SHOW,
    payload
});

export const setShowSettingModal = () => ({
    type: authConstants.SHOW_SETTING_MODAL
});

export const setShowModalUser = (payload) => ({
    type: authConstants.SHOW_MODAL_USER,
    payload
});

export const setShowPasswordResetModal = (payload) => ({
    type: authConstants.SHOW_PASSWORD_RESET_MODAL,
    payload
});

export const setUser = (user) => ({
    type: authConstants.EMAIL_VERIFICATION_CONFIRM_SUCCESS,
    payload: {
        user
    }
});
